import breakpoints from "../../constants/breakpoints";
import events from "../../constants/events";
import { debounce } from "../../utilities/functions";

import { Base } from "./Base";

const classes = {
  active: "active",
  hidden: "hidden",
  overflowing: "overflowing",
  sale: "sale",
};

const selectors = {
  mediaItem: ".product-card__media-item",
};

export class ProductCard extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.productData = {};
    this.swatchItems = [];
    this.mediaItems = [];
    this.colorOptionIndex = 0;
    this.initialActiveSwatchIndex = 0;
    this.c2s = false;
    this.videoObject = null;
    this.timer = null; 
    this.init();
  }

  init() {
    this.parseJsonData();
    this.cacheMediaItems();
    this.initSwatch();
    this.loadVideoData();
  }

  loadVideoData() {
    const videos = this.element.getElementsByClassName("media__video");
    if (videos) {
      const videoWrapper = videos[0];
      if (videoWrapper) {
        this.videoObject = String(videoWrapper.innerHTML).replace('loop' , 'loop autoplay');
        this.videoObject = this.videoObject.replace('source-lazy', 'source');
        videoWrapper.innerHTML = "";
      }
    }

    const { image } = this.refs;

    this.mouseOverHandler = this.mouseOver.bind(this);
    image.addEventListener("mouseenter", this.mouseOverHandler);

    this.mouseOutHandler = this.mouseOut.bind(this);
    image.addEventListener("mouseleave", this.mouseOutHandler);
  }

  parseJsonData() {
    const { json } = this.refs;

    if (json) {
      try {
        this.productData = JSON.parse(json.innerHTML);
        this.productData.image_alt = "";
        this.c2s =
          this.productData.tags && this.productData.tags.includes("c2s")
            ? true
            : false;
      } catch (e) {
        // Error in the JSON
      }
    }
  }

  mouseOut(e) {

    const videos = this.element.getElementsByClassName("media__video");
    if (videos) {
      const videoWrapper = videos[0];
      if (videoWrapper) {
        try {
          setTimeout(() => {
            videoWrapper.innerHTML = "";  
          }, 1000);
          
        } catch (error) {
          // console.log("RE / [ProductCard.js:75]: error: ", error);
        }
      }
    }
  }

  mouseOver(e) {
    const videos = this.element.getElementsByClassName("media__video");
    if (videos) {
      const videoWrapper = videos[0];
      if (videoWrapper) {
        try {
          videoWrapper.innerHTML = this.videoObject;
        } catch (error) {
          //console.log("RE / [ProductCard.js:75]: error: ", error);
        }
      }
    }
  }

  cacheMediaItems() {
    const { image } = this.refs;

    if (image) {
      this.mediaItems = Array.from(
        image.querySelectorAll(selectors.mediaItem)
      ).filter((item) => !item.classList.contains("hover"));
    }
  }

  initSwatch() {
    const { link, swatch, swatchItems } = this.refs;
    //console.log("RE / [ProductCard.js:120]: this.productData: ", this.productData);
    const { options, variants } = this.productData;

    if (swatch && swatchItems) {
      // Set color option index
      if (options) {
        for (let i = 0; i < options.length; i++) {
          if (options[i].name === "Color") {
            this.colorOptionIndex = i + 1;
            break;
          }
        }
      }

      // Init swatch items array
      this.swatchItems = Array.from(swatchItems.children).map(
        (swatchItem, index) => {
          const colorName = swatchItem.dataset.swatchName;
          let variantIndex = 0;

          // Get index of first variant for color
          if (variants) {
            for (let i = 0; i < variants.length; i++) {
              if (variants[i][`option${this.colorOptionIndex}`] === colorName && variants[i].available) {
                variantIndex = i;
                break;
              } 
            }
          }
          return {
            colorName: colorName,
            element: swatchItem,
            swatchIndex: index,
            variantIndex: variantIndex,
          };
        }
      );

      this.swatchItems.forEach((swatchItem, index) => {
        // Save initial active swatch item
        if (swatchItem.element.classList.contains(classes.active)) {
          this.initialActiveSwatchIndex = index;
        }

        // Add variant url
        if (link && variants) {
          swatchItem.element.href =
            link.href.split("?")[0] +
            "?variant=" +
            variants[swatchItem.variantIndex].id;
        }

        // Bind swatch item hover listener
        swatchItem.element.addEventListener("mouseenter", (e) => {
          this.setActiveSwatchItem(e.target);
        });
      });

      // Bind swatch mouseleave listener
      swatch.addEventListener("mouseleave", () => {
        this.setActiveSwatchItem(
          this.swatchItems[this.initialActiveSwatchIndex].element
        );
      });

      // Bind resize handler
      this.bindResizeHandler();

      // Set initial swatch width
      this.updateSwatchWidth();

      // Listen for filter content updated to set initial width
      window.addEventListener(events.FILTER_CONTENT_UPDATED, () => {
        this.updateSwatchWidth();
      });
    }
  }

  setActiveSwatchItem(target) {
    this.swatchItems.forEach((swatchItem) => {
      if (target === swatchItem.element) {
        this.activateSwatchItem(swatchItem);
      }
    });
  }

  activateSwatchItem(swatchItem) {
    this.updateImage(swatchItem);
    this.updatePrice(swatchItem);
  }

  updateImage(swatchItem) {
    this.mediaItems.forEach((mediaItem, index) => {
      if (index === swatchItem.swatchIndex) {
        mediaItem.classList.remove(classes.hidden);
      } else {
        mediaItem.classList.add(classes.hidden);
      }
    });
  }

  updatePrice(swatchItem) {
    if (this.c2s) {
      return;
    }

    const { variants } = this.productData;
    const { price } = this.refs;
    const selectedVariant = variants[swatchItem.variantIndex];
    const { compare_at_price, price: variant_price } = selectedVariant;

    if (
      parseInt(selectedVariant.compare_at_price_in_hundreds) >
      parseInt(selectedVariant.price_in_hundreds)
    ) {
      this.element.classList.add(classes.sale);
    } else {
      this.element.classList.remove(classes.sale);
    }

    let priceHTML = variant_price;

    if (compare_at_price) {
      priceHTML =
        `<span class="product-card__original-price">${compare_at_price}</span>` +
        priceHTML;
    }

    price.innerHTML = priceHTML;
  }

  bindResizeHandler() {
    this.resizeHandler = debounce(() => {
      this.updateSwatchWidth();
    }, 250);

    window.addEventListener("resize", this.resizeHandler);
  }

  updateSwatchWidth() {
    const { swatch, swatchItems } = this.refs;

    // Initialize variables
    let isOverflowing = false;
    let maxSwatchWidth = 0;
    let swatchItemArray = [];
    let swatchItemCount = 0;
    let swatchItemWidth = 0;
    let swatchFirstItem;
    let swatchItemStyle;
    let visibleSwatches = 0;

    if (swatch && swatchItems) {
      // Set max width dependant on breakpoint
      if (window.innerWidth >= breakpoints.MD) {
        maxSwatchWidth = swatch.offsetWidth * 0.75;
      } else {
        maxSwatchWidth = swatch.offsetWidth * 0.6;
      }

      swatchItemArray = Array.from(swatchItems.children);
      swatchItemCount = swatchItemArray.length;

      if (swatchItemCount > 0) {
        // Get swatch properties
        swatchFirstItem = swatchItemArray[0];
        swatchItemStyle =
          swatchFirstItem.currentStyle ||
          window.getComputedStyle(swatchFirstItem);
        swatchItemWidth =
          swatchFirstItem.offsetWidth +
          parseInt(swatchItemStyle.marginRight, 10);

        // Get visible swatch count
        visibleSwatches = Math.floor(maxSwatchWidth / swatchItemWidth);

        // Hide and show swatch items
        for (let i = 0; i < swatchItemCount; i++) {
          if (i >= visibleSwatches) {
            isOverflowing = true;
            swatchItemArray[i].classList.add(classes.hidden);
          } else {
            swatchItemArray[i].classList.remove(classes.hidden);
          }
        }

        // Set global overflowing class
        if (isOverflowing) {
          swatch.classList.add(classes.overflowing);
        } else {
          swatch.classList.remove(classes.overflowing);
        }
      }
    }
  }

  cleanup() {
    const { image } = this.refs;
    image.removeEventListener("mouseenter", this.mouseOutHandler);
    image.removeEventListener("mouseleave", this.mouseOverHandler);
    window.removeEventListener("resize", this.resizeHandler);
    if(this.timer) clearTimeout(this.timer);
  }
}
